import { AppDebug, AppDebugLogType } from "../app/debug/AppDebug";
import { TextStatesData } from "../types/types";
import { GetBounds } from "../utils/GetBounds";
import { ButtonBase } from "./ButtonBase";


/**
 * ButtonBase with a Label
 * 
 * @example:
 *  const myButton = new LabelButton(..)
 *  myButton.InitBase(..)
 *  myButton.InitLabel(..)
 *  myButton.PostInit(..)
 *  this.add(myButton);
 */
 export class LabelButton extends ButtonBase
 {
     public label: Phaser.GameObjects.Text;
     /**
      * Label texture states to match @see ButtonBase::buttonTextureDatas
      */
     protected labelStatesData: TextStatesData;
 
 
     /**
      * Initialize this button's label
      * 
      * @param isInteractive Should button by default be in its enabled state, or disable state?
      *      NOTE: by default, the button is in its enabled state; To change this default state, 
      *            call this function with isInteractive=false;
      * @returns 
      */
     public InitLabel(
         labelStatesData: TextStatesData,
         labelOffset?: Phaser.Geom.Point,
     ): void
     {
         this.labelStatesData = labelStatesData;
 
         this.label = this.scene.make.text({style: labelStatesData.out});
         this.add(this.label);
 
         if (labelOffset) {
             this.label.setPosition(labelOffset.x, labelOffset.y);
         }
     }
 
     protected override UpdateViewFromInteractive(): void
     {
         // toggle button texture view update
         super.UpdateViewFromInteractive();
 
         // was disabled, is enabled
         if (this.isInteractive) {
             if (this.labelStatesData.disabled != null) {
                 this.label.setStyle(this.labelStatesData.out);
             }
         }
         // was enabled, is disabled
         else {
             if (this.labelStatesData.disabled != null) {
                 this.label.setStyle(this.labelStatesData.disabled);
             }
         }
     }
     
     protected override OnPointerOver(): void
     {
         super.OnPointerOver();
 
         if (this.isInteractive) {
             if (this.labelStatesData.over != null) {
                 this.label.setStyle(this.labelStatesData.over);
             }
         }
     }
     
     protected override OnPointerOut(): void
     {
         // console.log("LabelIconButton::OnPointerOut");
 
         super.OnPointerOut();
 
         if (this.isInteractive) {
             if (this.labelStatesData.out != null) {
                 this.label.setStyle(this.labelStatesData.out);
             }
         }
     }
 
     protected override UpdateHitArea(): void
     {
         super.UpdateHitArea();
         
         const labelRect: Phaser.Geom.Rectangle = GetBounds(this.label, this.hitAreaExtrusion);
         Phaser.Geom.Rectangle.Union(this.cachedHitArea, labelRect, this.cachedHitArea);
 
         if (this.input != null) {
             this.input.hitArea = this.cachedHitArea;
             this.input.hitAreaCallback = this.cachedHitAreaCallback;
         }
     }
 
     public SetText(value: string, updateHitArea: boolean = true): void
     {
         this.label.text = value;
 
         if (updateHitArea) {
             this.UpdateHitArea();
         }
     }
     
     public override destroy(): void
     {
         super.destroy();
 
         this.label.destroy();
         this.label = null;

         this.labelStatesData = null;
     }
 }